import React from 'react'
import { CButton, CModal, CModalBody, CModalHeader, CModalFooter } from '@coreui/react'
import ClipboardCopy from 'src/components/copyToClipboard'

const ShareModal = ({ details = [], onClose, modalTitle = '' }) => {
  return (
    <CModal scrollable size="lg" visible={true} alignment="center" className="">
      <CModalHeader style={{}} className="d-flex flex-column align-items-start mt-1 px-5">
        <div className="d-flex justify-content-center w-100">
          <p style={{ fontSize: '1.2rem' }} className="">
            <b style={{ fontWeight: '500', color: '#191818' }}>{modalTitle}</b>
          </p>
        </div>
      </CModalHeader>
      <CModalBody>
        {details.map((detail, idx) => (
          <>
            <h6 style={{ fontSize: '15px', color: '#191919' }} className={`${idx !== 0 && 'mt-3'}`}>
              {detail.title}
            </h6>
            <ClipboardCopy copyText={detail.data} />
          </>
        ))}
      </CModalBody>
      <CModalFooter>
        <CButton
          style={{ fontSize: '1.1rem' }}
          className=" bg-black rounded-1 btn-focus-none"
          onClick={onClose}
        >
          Close
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default ShareModal
